import api from './axios';

export const getKvkkPending = () => api.get('/kvkk/pending');
export const acceptKvkk = (type, decision = 'accept') => api.post('/kvkk/accept', { type, decision });
export const getMyConsents = () => api.get('/kvkk/my-consents');
export const getMyKvkkStatus = () => api.get('/kvkk/my-status');
export const getKvkkPendingUsers = (type) => api.get(`/kvkk/types/${type}/pending`);
export const getKvkkText = (type) => api.get(`/kvkk/text/${type}`);
export const updateKvkkText = (type, data) => api.put(`/kvkk/text/${type}`, data);
export const getKvkkConsents = (params) => api.get('/kvkk/consents', { params });
export const revokeKvkkConsent = (id) => api.patch(`/kvkk/consents/${id}/revoke`);
export const getKvkkTypes = () => api.get('/kvkk/types');
export const createKvkkType = (data) => api.post('/kvkk/types', data);
export const updateKvkkType = (id, data) => api.patch(`/kvkk/types/${id}`, data);
export const deleteKvkkType = (id) => api.delete(`/kvkk/types/${id}`);
export const getStudentKvkkConsents = (studentId) => api.get(`/students/${studentId}/kvkk-consents`);
export const decideStudentKvkkConsent = (studentId, type, decision) =>
  api.post(`/students/${studentId}/kvkk-consents/decide`, { type, decision });
